/* HTML教材の漫画画像ビューア。
 * クリック/Enter/Spaceで開き、複数画像ならボタン・矢印キー・スワイプで送る。
 */
(function () {
  "use strict";

  var ROOT_SEL = "[data-html-article]";
  var IMAGE_SEL = ".html-article__body figure.manga img";
  var ENTRY_SEL = "[data-hta-entry]";
  var PR_CHANCE = 0.3;
  var SWIPE_MIN = 48;
  var URL_PARAM = "img";
  var MOBILE = window.matchMedia("(max-width: 600px)");

  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var box = root.querySelector("[data-hta-lightbox]");
  var image = root.querySelector("[data-hta-lightbox-img]");
  var figure = root.querySelector("[data-hta-lightbox-figure]");
  var caption = root.querySelector("[data-hta-lightbox-caption]");
  var closeButton = root.querySelector("[data-hta-lightbox-close]");
  if (!box || (!image && !figure) || !caption || !closeButton) return;

  var prevButton = root.querySelector("[data-hta-lightbox-prev]");
  var nextButton = root.querySelector("[data-hta-lightbox-next]");
  var countLabel = root.querySelector("[data-hta-lightbox-count]");
  var prBox = root.querySelector("[data-hta-lightbox-pr-box]");
  var prTemplate = root.querySelector("[data-hta-lightbox-pr-template]");

  var lastFocus = null;
  var savedOverflow = "";
  var items = [];
  var index = 0;
  var prShowing = false;
  var prFrom = 0;
  var prTarget = 0;
  var prDir = 1;
  var lastWasPr = false;
  var dragX = 0;
  var dragY = 0;
  var dragging = false;
  var dragSwiped = false;

  function ensureImage() {
    if (image) return image;
    image = document.createElement("img");
    image.className = "hta-lightbox__img";
    image.setAttribute("data-hta-lightbox-img", "");
    image.alt = "";
    figure.insertBefore(image, figure.firstChild);
    return image;
  }

  function captionFor(img) {
    var figure = img.closest("figure");
    var figcaption = figure ? figure.querySelector("figcaption") : null;
    return [(figcaption ? figcaption.textContent : "").trim(), (img.getAttribute("alt") || "").trim()]
      .filter(Boolean).join(" — ");
  }

  function setUrlPage(number) {
    if (root.getAttribute("data-url-params") !== "true") return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set(URL_PARAM, String(number));
      history.replaceState(history.state, "", url);
    } catch (error) { /* URL APIが無い環境では表示だけ続ける */ }
  }

  function clearUrlPage() {
    if (root.getAttribute("data-url-params") !== "true") return;
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(URL_PARAM)) return;
      url.searchParams.delete(URL_PARAM);
      history.replaceState(history.state, "", url);
    } catch (error) { /* noop */ }
  }

  function updateNav() {
    if (!prevButton || !nextButton) return;
    var single = items.length <= 1;
    prevButton.hidden = single;
    nextButton.hidden = single;
    if (single) return;
    if (prShowing) {
      prevButton.disabled = false;
      nextButton.disabled = false;
      return;
    }
    prevButton.disabled = index <= 0;
    nextButton.disabled = index >= items.length - 1;
  }

  function updateCount() {
    if (!countLabel) return;
    countLabel.textContent = items.length > 1 && !prShowing
      ? (index + 1) + " / " + items.length
      : "";
  }

  function showImage(nextIndex) {
    var img = items[nextIndex];
    if (!img) return;
    ensureImage();
    index = nextIndex;
    prShowing = false;
    if (prBox) { prBox.hidden = true; prBox.textContent = ""; }
    image.hidden = false;
    image.src = img.currentSrc || img.src;
    image.alt = img.getAttribute("alt") || "";
    caption.textContent = captionFor(img);
    box.classList.remove("hta-lightbox--wide");
    box.scrollTop = 0;
    setUrlPage(nextIndex + 1);
    updateNav();
    updateCount();
  }

  function showPr(fromIndex, targetIndex) {
    if (!prBox || !prTemplate) return false;
    var content = prTemplate.content
      ? prTemplate.content.firstElementChild
      : prTemplate.firstElementChild;
    if (!content) return false;
    prBox.textContent = "";
    prBox.appendChild(content.cloneNode(true));
    prBox.hidden = false;
    image.hidden = true;
    caption.textContent = "PR";
    prShowing = true;
    prFrom = fromIndex;
    prTarget = targetIndex;
    prDir = targetIndex >= fromIndex ? 1 : -1;
    lastWasPr = true;
    box.scrollTop = 0;
    updateNav();
    updateCount();
    return true;
  }

  function advance(direction) {
    if (prShowing) {
      showImage(direction === prDir ? prTarget : prFrom);
      return;
    }
    var target = index + direction;
    if (target < 0 || target >= items.length) return;
    if (!lastWasPr && Math.random() < PR_CHANCE && showPr(index, target)) return;
    lastWasPr = false;
    showImage(target);
  }

  function open(img) {
    lastFocus = document.activeElement;
    var scope = root.hasAttribute("data-hta-gallery-all")
      ? root
      : (img.closest(ENTRY_SEL) || root);
    items = Array.prototype.slice.call(scope.querySelectorAll(IMAGE_SEL));
    var at = items.indexOf(img);
    if (at < 0) { items = [img]; at = 0; }
    lastWasPr = false;
    box.hidden = false;
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    showImage(at);
    closeButton.focus();
  }

  function close() {
    if (box.hidden) return;
    box.hidden = true;
    box.classList.remove("hta-lightbox--wide");
    if (prBox) { prBox.hidden = true; prBox.textContent = ""; }
    prShowing = false;
    image.hidden = false;
    clearUrlPage();
    document.body.style.overflow = savedOverflow;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener("click", function (event) {
    var img = event.target.closest(IMAGE_SEL);
    if (!img || box.contains(img)) return;
    event.preventDefault();
    open(img);
  });

  root.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var img = event.target.closest(IMAGE_SEL);
    if (!img || box.contains(img)) return;
    event.preventDefault();
    open(img);
  });

  if (prevButton) prevButton.addEventListener("click", function (event) {
    event.stopPropagation();
    advance(-1);
  });
  if (nextButton) nextButton.addEventListener("click", function (event) {
    event.stopPropagation();
    advance(1);
  });
  if (prBox) prBox.addEventListener("click", function (event) { event.stopPropagation(); });

  box.addEventListener("click", function (event) {
    if (event.target.closest("[data-hta-lightbox-img]")) {
      event.stopPropagation();
      if (dragSwiped) { dragSwiped = false; return; }
      if (!MOBILE.matches) return;
      box.classList.toggle("hta-lightbox--wide");
      if (box.classList.contains("hta-lightbox--wide")) box.scrollTop = 0;
      return;
    }
    if (dragSwiped) { dragSwiped = false; return; }
    close();
  });
  closeButton.addEventListener("click", function (event) {
    event.stopPropagation();
    close();
  });

  document.addEventListener("keydown", function (event) {
    if (box.hidden) return;
    if (event.key === "Escape") { close(); return; }
    if (event.key === "Tab") {
      var focusable = Array.prototype.slice.call(box.querySelectorAll(
        'button:not([hidden]):not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      )).filter(function (node) { return node.getClientRects().length > 0; });
      if (!focusable.length) { event.preventDefault(); closeButton.focus(); return; }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
      return;
    }
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.key === "ArrowLeft") { event.preventDefault(); advance(1); }
    if (event.key === "ArrowRight") { event.preventDefault(); advance(-1); }
  });

  box.addEventListener("pointerdown", function (event) {
    if (event.pointerType === "mouse" && event.button !== 0) return;
    if (prBox && prBox.contains(event.target)) return;
    dragging = true;
    dragSwiped = false;
    dragX = event.clientX;
    dragY = event.clientY;
  });

  box.addEventListener("pointerup", function (event) {
    if (!dragging) return;
    dragging = false;
    var dx = event.clientX - dragX;
    var dy = event.clientY - dragY;
    if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    dragSwiped = true;
    advance(dx > 0 ? 1 : -1);
  });
  box.addEventListener("pointercancel", function () { dragging = false; });

  function markImages() {
    Array.prototype.forEach.call(root.querySelectorAll(".html-article__body figure.manga"), function (figure) {
      if (figure.hasAttribute("data-hta-zoomable")) return;
      figure.setAttribute("data-hta-zoomable", "");
      var zoomTarget = figure.querySelector("img");
      if (!zoomTarget) return;
      zoomTarget.setAttribute("tabindex", "0");
      zoomTarget.setAttribute("role", "button");
      zoomTarget.setAttribute("aria-label", "画像を大きく表示する");
    });
  }

  var main = root.querySelector(".html-article__main") || root;
  new MutationObserver(markImages).observe(main, { childList: true });
  markImages();
  if (box.hidden) clearUrlPage();
})();
